import { render } from "./new-area.vue?vue&type=template&id=5f8cd9d8"
import script from "./new-area.vue?vue&type=script&lang=js"
export * from "./new-area.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__